export default class TcpaShieldService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }


  getSecureUrl(accountId) {
    const url = this.#serviceBaseUrl(accountId) +'/secure-urls';
    return this.$http.get(url).then((response) => {
      return response.data;
    });
  }

  getUrls(accountId) {
    const url = this.#serviceBaseUrl(accountId) + '/urls';
    return this.$http.get(url).then((response) => {
      return response.data;
    });
  }

  uploadFile(accountId, file) {
    const url = this.#serviceBaseUrl(accountId) + '/process-file';

    const fd = new FormData();
    fd.append(file.name, file);

    return this.$http.post(url, fd, {
      headers: { 'Content-Type': undefined }
    }).then((data) => {
      // https://stackoverflow.com/questions/14215049/how-to-download-file-using-angularjs-and-calling-mvc-api
      const fileContent = new Blob([data.data], {
        type: data.headers('Content-Type')
      });
      //trick to download store a file having its URL
      const fileURL = URL.createObjectURL(fileContent);
      const a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = file.name;
      document.body.appendChild(a); //create the link "a"
      a.click(); //click the link "a"
      document.body.removeChild(a); //remove the link "a"
    });
  }

  getHistory(accountId) {
    const url = this.#serviceBaseUrl(accountId) + '/history';
    return this.$http.get(url).then((response) => {
      return response.data;
    });
  }

  #serviceBaseUrl(accountId) {
    return this.serviceBaseUri + accountId + '/TCPAShield';
  }
}
